<script>
    //screens
	import PickGame from './PickGame.svelte';
	import Game from './Game.svelte';
	import Menu from './Menu.svelte';
	import Email from './Email.svelte';
	import Settings from './Settings.svelte';
	import About from './About.svelte';
	//audio files
	import { audioData } from './audioData.js';
	//stores
	import {play_sound} from './stores.js';
	
	export let ScreenVar = 0; //0 menu, 1 problem selection, 2 problem solver, 3 user info, 4 guide, 5 settings, 6 about(in guide), etc.
	export let GameID=0;
	
	//switch to a game if ever selected
	$: if( GameID > 0){
		ScreenVar = 2;
	}
	
	let audioButtonclick  = new Audio(audioData['buttonclick'].url);
	
	function MenuButton(){
	    if ($play_sound)
	        audioButtonclick.play();
	    //reset app    
		ScreenVar=0; GameID=0;
	}
	/*$('body').css({
		transform: 'scale(.8)', // set zoom
		transformOrigin: '50% 0' // set transform scale base
	});*/
</script>
<style> 
	:global(body) {
		/* this will apply to <body> */
		background-color:#000000;
		color:#FFFFFF;
		font-weight:bold;
		font-family:monospace,monospace;
		/*font-size:15px;*/
	}
	:global(h3) {
		/* this will apply to <body> */
		font-size:16px;
		text-align:center;
		font-weight:bold;
		font-family:monospace,monospace;
		height:18px;
		margin-top:0px;
		padding-top:0px;
	}
	h1{
		text-align:center;
	}
	#menbutloc{
		text-align:center;
		width:400px;
		margin:auto auto;		
	}
	.menbut{
		height:40px;
		font-size:26px;
		text-align:center;
		font-family:monospace,monospace;
		font-weight:bold;
		color:#ffffff;
		background-color:#000000;
		border-width:0px;
		cursor:pointer;
	}
	.buts_sym{ font-size:25px;float:left;text-align:left;}
</style>
<div id="menbutloc">
	<button on:click="{MenuButton}" class="menbut"><!--&#8801;-->TIS-10 Trainer Board</button>
	<!--<h1>TIS-10 Trainer Board</h1>-->
</div>


{#if ScreenVar == 0}
	<Menu bind:MenuChoice={ScreenVar}/> 
{:else if ScreenVar == 1}
	<PickGame bind:GameID={GameID}/>
{:else if ScreenVar == 2}
	<Game bind:CurrGameID={GameID}/>
{:else if ScreenVar == 3}
   <Settings />
{:else if ScreenVar == 4}
   <Email />
{:else if ScreenVar == 5}
    <About />
{/if}

